// Modification de la liste des étudiants : jamais hors ligne (pas de file d'attente).

export const OFFLINE_EDIT_MESSAGE = 'Hors réseau : la liste des étudiants ne peut pas être modifiée. Réessayez une fois connecté.';

/** Message à afficher si la modification est impossible maintenant, sinon ''. */
export function studentEditBlocked({ online = true, listOffline = false } = {}) {
  return !online || listOffline ? OFFLINE_EDIT_MESSAGE : '';
}

/** Erreur réseau (pas de réponse du serveur) : même message clair que hors ligne. */
export function studentEditError(error, fallback = 'Action impossible') {
  if (error && !error.response) return OFFLINE_EDIT_MESSAGE;
  const detail = error?.response?.data?.detail;
  return typeof detail === 'string' ? detail : fallback;
}

/** Champs envoyés au serveur : texte nettoyé, chambre obligatoire. */
export function studentPayload(values = {}) {
  const fields = ['last_name', 'first_name', 'room', 'bed', 'departure', 'class_name', 'floor'];
  const payload = {};
  fields.forEach((field) => { payload[field] = String(values[field] ?? '').trim(); });
  return payload;
}

export function studentFormError(values = {}) {
  const payload = studentPayload(values);
  if (!payload.room) return 'La chambre est obligatoire.';
  if (!payload.last_name && !payload.first_name) return 'Indiquez au moins un nom ou un prénom.';
  if (payload.departure && !/^\d{2}\.\d{2}\.\d{4}$/.test(payload.departure)) return 'Départ au format JJ.MM.AAAA.';
  return '';
}
